<template>
    <div id="submission">
        <Banner title="投稿專區" :breadcrumbs="breadcrumbs" type="submission"></Banner>
        <div class="container">
            <div class="center_title">
                <Title en="Online submission" chtFirst="線上" chtSecond="投稿" :center="true"></Title>
            </div>
            <section class="list_box" v-if="!Detail.Id">
                <div
                    class="list"
                    v-infinite-scroll="loadMore"
                    infinite-scroll-disabled="busy"
                    infinite-scroll-distance="10"
                    v-show="list.length > 0"
                >
                    <div class="item" v-for="(item,index) in list" :key="index">
                        <ImageCard :data="item" type="submission"></ImageCard>
                    </div>
                </div>
                <notfound v-if="list.length == 0" info="目前尚未開放線上投稿，"></notfound>
            </section>
            <transition>
                <section v-if="Detail.Id">
                    <div class="box">
                        <h3 class="title">{{Detail.Title}}</h3>
                        <div class="img">
                            <img :src="Detail.Image" :alt="Detail.Title" />
                        </div>
                        <div class="border"></div>
                        <div class="tr">
                            <div>投稿日期</div>
                            <div>{{Detail.StartOn.split("T")[0] + " ~ " + Detail.EndOn.split("T")[0]}}</div>
                        </div>
                        <div class="tr" v-if="Detail.DocumentFile">
                            <div>檔案下載</div>
                            <a href="javascript:;" @click="download(Detail.DocumentFile)">檔案下載</a>
                        </div>
                        <div class="content" v-html="Detail.Content"></div>
                        <div class="btn_box" v-if="!Submission && new Date() < new Date(Detail.EndOn)">
                            <div class="Orange_btn islogin" @click="openSubmission">
                                <a href="javascript:;">我要投稿</a>
                            </div>
                        </div>
                        <form class="submission_box" :class="{'active':Submission}" ref="form">
                            <div class="subtitle">填寫投稿人資訊</div>
                            <input type="hidden" name="Id" :value="guid" />
                            <div class="input_span">
                                <span>姓名</span>
                                <input type="text" name="Name" v-model="formData.Name" />
                            </div>
                            <div class="input_span">
                                <span>聯絡電話</span>
                                <input type="text" name="Mobile" v-model="formData.Mobile" />
                            </div>
                            <div class="input_span">
                                <span>E-mail</span>
                                <input type="text" name="Email" v-model="formData.Email" />
                            </div>
                            <div class="input_span">
                                <span>服務醫院</span>
                                <input
                                    type="text"
                                    name="Affiliation"
                                    v-model="formData.Affiliation"
                                />
                            </div>
                            <div class="input_span">
                                <span>職稱</span>
                                <input type="text" name="Position" v-model="formData.Position" />
                            </div>
                            <div class="input_span">
                                <span>附件</span>
                                <label for="file" v-show="!fullFileName">上傳檔案</label>
                                <input
                                    id="file"
                                    ref="file"
                                    type="file"
                                    name="File"
                                    @change="toInputValue($event)"
                                />
                                <div class="note" v-show="!fullFileName">，檔案請小於10MB</div>
                                <div class="file_name" v-show="fullFileName">
                                    <input type="text" id="forFile" v-model="fullFileName" />
                                    <div class="delete" @click="deleteFile">
                                        <span>✖</span>
                                        <span>刪除</span>
                                    </div>
                                </div>
                            </div>
                            <div class="btn_box">
                                <div class="item">
                                    <div class="White_btn islogin" @click="reset">
                                        <a href="javascript:;">重新填寫</a>
                                    </div>
                                </div>
                                <div class="item">
                                    <div class="Orange_btn islogin" @click="submit">
                                        <a href="javascript:;">確定送出</a>
                                    </div>
                                </div>
                            </div>
                        </form>
                    </div>
                    <graybtn name="回列表頁" url="back" />
                </section>
            </transition>
        </div>
        <loading v-if="isLoading"></loading>
    </div>
</template>

<script>
import ImageCard from "@/components/submission/imgCard";
import API from "@/service/submission";
import Common from "@/common";
export default {
    name: "submission",
    components: {
        ImageCard
    },
    props: ["propsubmission"],
    data() {
        return {
            breadcrumbs: [
                {
                    url: "/",
                    title: "首頁"
                },
                {
                    title: "投稿專區"
                },
                {
                    url: "/submission",
                    title: "線上投稿"
                }
            ],
            Page: 1,
            Count: 6,
            Totalpage: 1,
            busy: false,
            submissionId: "", //投稿ID
            guid: "",
            Detail: {
                Id: "",
                Title: "",
                Image: "",
                StartOn: "",
                EndOn: "",
                Content: ""
            },
            Submission: false,
            list: [],
            myFile: [],
            fileName: "",
            fullFileName: "",
            formData: {
                Name: "",
                Mobile: "",
                Email: "",
                Affiliation: "",
                Position: ""
            },
            isLoading: false
        };
    },
    methods: {
        openSubmission() {
            const vm = this;
            if (vm.Submission) {
                return false;
            }
            vm.Submission = true;
        },
        back() {
            window.history.go(-1);
        },
        loadMore() {
            const vm = this;
            vm.busy = true;
            // console.log("Totalpage", vm.Totalpage);
            // console.log("Page", vm.Page);
            if (vm.Totalpage <= 1 || vm.Totalpage == vm.Page) {
                return false;
            }
            vm.Page += 1;
            vm.isLoading = true;
            API.getSubmissionList({ page: vm.Page, count: vm.Count }).then(
                res => {
                    if (res.Ok) {
                        vm.list = vm.list.concat(res.Data.Submissions);
                        setTimeout(function() {
                            vm.busy = false;
                        }, 1000);
                    }
                    setTimeout(function() {
                        vm.isLoading = false;
                    }, 500);
                }
            );
        },
        toInputValue(e) {
            const vm = this;
            let File = e.target.files || e.dataTransfer.files;
            if (File[0].size > 10485760) {
                vm.$swal({
                    type: "warning",
                    text: "檔案大小超過 2MB，請重新選擇檔案",
                    confirmButtonText: "確定"
                });
                return false;
            }
            vm.myFile = File[0];            
            const tmpFileName = File[0].name.split('.');
            if(tmpFileName.length >=2) {
                vm.fileName = tmpFileName[0];
            } else {
                vm.fileName = File[0].name;
            }
            vm.fullFileName = File[0].name;
            if(!/^[\u4e00-\u9fa5_a-zA-Z0-9]+$/.test(vm.fileName)) {
                vm.$swal({
                    type: "warning",
                    text: "檔名請勿使用特殊符號或空格",
                    confirmButtonText: "確定"
                }).then(function(data) {
                    if(data.value) {
                        vm.deleteFile()
                    }
                });
            }
        },
        deleteFile() {
            const vm = this;
            vm.myFile = [];
            vm.fileName = "";
            vm.fullFileName = "";
            vm.$refs.file.value = "";
        },
        submit() {
            const vm = this;
            if (
                !vm.formData.Name ||
                !vm.formData.Mobile ||
                !vm.formData.Email ||
                !vm.formData.Affiliation ||
                !vm.formData.Position ||
                !vm.myFile ||
                !vm.fileName
            ) {
                vm.$swal({
                    type: "warning",
                    text: "尚有欄位未填寫",
                    confirmButtonText: "確定"
                });
                return false;
            } else {
                vm.fileName = vm.fileName + `-${vm.formData.Name}-${new Date().valueOf()}`
                let formData = new FormData();
                formData.append("Id", vm.guid);
                // formData.append("Id", vm.fileName);
                formData.append("Name", vm.formData.Name);
                formData.append("Mobile", vm.formData.Mobile);
                formData.append("Telephone", vm.formData.Mobile);
                formData.append("Email", vm.formData.Email);
                formData.append("Affiliation", vm.formData.Affiliation);
                formData.append("Position", vm.formData.Position);
                formData.append("Filename", vm.fileName);
                formData.append("File", vm.myFile, vm.fullFileName);
                // console.log(vm.myFile);
                // for (var pair of formData.entries()) {
                //   console.log(pair[0] + ", " + pair[1]);
                // }
                vm.isLoading = true;
                API.getSubmitSubmissions(vm.submissionId, formData).then(
                    res => {
                        // console.log(res);
                        setTimeout(function() {
                            vm.isLoading = false;
                        }, 500);
                        if (res.Ok) {
                            vm.$swal({
                                type: "success",
                                text: "投稿成功!",
                                confirmButtonText: "確定"
                            });
                            vm.reset();
                            let UrlString = location.href;
                            let Url = new URL(UrlString);
                            vm.submissionId = vm.getParamsId('Id');// Url.searchParams.get("Id");
                        } else {
                            vm.$swal({
                                type: "fail",
                                text:
                                    "投稿失敗，請檢查您所填寫欄位及上傳的檔案，或著稍後在試!",
                                confirmButtonText: "確定"
                            });
                        }
                    }
                );
                // vm.$refs.form.submit();
            }
        },
        reset() {
            const vm = this;
            vm.formData = {
                Name: "",
                Mobile: "",
                Email: "",
                Affiliation: "",
                Position: ""
            };
            vm.deleteFile();
        },
        download(url) {
            const vm = this;
            let Type = url
                .split("/")
                .pop()
                .split(".")
                .pop();
            Common.download(url, { type: Type });
        },
        getParamsId(name){
            var results = new RegExp('[\?&]' + name + '=([^&#]*)').exec(window.location.href);
            if (results == null){
                return null;
            }
            else {
                return decodeURI(results[1]) || 0;
        }
}
    },
    computed: {},
    created() {
        const vm = this;
        let UrlString = location.href;
        let Url = new URL(UrlString);
        let Id = vm.getParamsId('Id');
        vm.submissionId = vm.getParamsId('Id');
        vm.guid = Common.generateUUID();
        if (Id !== null) {
            if (process.env.NODE_ENV === "production") {
                API.getSubmissionDetail({ Id: Id }).then(res => {
                    if (res.Ok) {
                        vm.Detail = res.Data;
                    }
                });
            } else {
                vm.Detail = {
                    Id: "test0101",
                    Title: "艾利根論文獎甄選活動!!",
                    Image: require("@/assets/dev/img2.png"),
                    StartOn: "2019-07-11T00:00:00",
                    EndOn: "2019-08-17T00:00:00",
                    DocumentFile:
                        "https://retinasociety.blob.core.windows.net/submission/eeb70bfb-ea96-4fb9-8957-59ec9131cf68/9a66c81ffdd24878b9821af506da5f22.doc",
                    Content: `   <p>親愛的會員您好:</p>
              <p>
                今年的第八屆TRS年會將會與第十五屆世界眼炎醫學會年會「15th International Ocular Inflammation Society (IOIS) Congress」假高雄展覽館合辦。其中IOIS會期為108年11月13日至16日(星期三至星期六)，而
                <strong>TRS年會將會於民國108年11月16日(星期六)舉辦</strong>，年會中包含一Free Paper Presentation時段，題目不拘，預定講者八名。另今年第四屆台日聯合會將會同日本視網膜醫學會年會(108年12月6日至8日)在日本長崎舉辦，同往例包含Rapid Fire單元，題目不拘，預定講者八名。
              </p>
              <p>本會現針對第八屆視網膜醫學會年會Free Paper及第四屆台日聯合會Rapid Fire舉辦聯合徵稿活動，在此敬邀各位會員踴躍投稿。投稿注意事項如下</p>
              <ul>
                <li>(一) 投稿台日Rapid-Fire並獲選報告者，將依據往例日方提供報名費及住宿，本會提供新台幣一萬元整交通補助。</li>
                <li>(二) 第一階段評選: 無論投稿Free Paper或Rapid Fire，Abstract篩選獲選者，需於108年8月4日本年度第二次Retina club中報告，並由本會學術委員會選出最終適合報告之論文。</li>
                <li>
                  (三) 今年在諾華公司贊助下，設立「影像與疾病趨勢專題」研究獎，學術委員會及評審將就108年8月4日之預報內容評審，選出nAMD研究組兩名DR/DME研究組兩名，共計四名得獎者，
                  <span
                    style="backgroundColor:#ff0;"
                  >各頒予NTD 20,000現金</span>。申請人須為該論文之第一作者，且該研究需為台灣本土之研究資料，尚未於其他處發表。評選內容將同時依據摘要與上台報告時呈現之影像及內容評之。
                </li>
                <li>
                  (四) 敬請各位會員於
                  <strong>6月20日</strong>前填好abstract form (如附件)電郵交付TRS辦公室，投稿時務必註明想在台日報告、想在IOIS報告、或均可。
                </li>
              </ul>
              <p>另本會今年協辦第十五屆IOIS Congress，秘書處在此亦鼓勵各位會員及所屬住院醫師踴躍報名參加及投稿，其中Abstract投稿現已開放，截止日期為6月1日。</p>
              <p>
                相關投稿事項請至IOIS網站:
                <a
                  href="https://www.iois.info/page.php?edi_id=1463"
                >https://www.iois.info/page.php?edi_id=1463</a>。本會為鼓勵住院醫師多參與此次會議，凡住院醫師投稿IOIS獲選者，學會即補助會議報名費NTD 3,000元整。(本國住院醫師報名費早鳥價150 EURO)
              </p>
              <p>這些會議均是千載難逢與國際專家交流的好機會，歡迎大家多多踴躍參與投稿，千萬不要錯過囉!!</p>
              <p>中華民國視網膜醫學會 陳世真 理事長</p>
              <p>第八屆會員大會暨學術演講會/第15屆IOIS醫學會年會</p>
              <p>許淑娟 會長 敬邀</p>`
                };
            }
        } else {
            //獲取投稿清單
            if (vm.propsubmission) {
                let obj = JSON.parse(vm.propsubmission);
                vm.list = obj.Submissions;
                vm.Totalpage = Math.ceil(parseInt(obj.Total) / vm.Count);
            } else {
                //假資料投稿清單
                vm.list = [
                    {
                        Id: "test0101",
                        Title: "艾利根論文獎甄選活動!!",
                        Image: require("@/assets/dev/img2.png"),
                        StartOn: "2019-07-11T00:00:00",
                        EndOn: "2019-08-17T00:00:00"
                    },
                    {
                        Id: "test0101",
                        Title: "台日聯合會議-投稿",
                        Image: require("@/assets/dev/img3.png"),
                        StartOn: "2019-07-11T00:00:00",
                        EndOn: "2019-08-17T00:00:00"
                    },
                    {
                        Id: "test0101",
                        Title:
                            "第八屆視網膜醫學會年會Free Paper 及第四屆台日聯合會Rapid Fire聯合徵稿活動!!",
                        Image: require("@/assets/dev/img4.png"),
                        StartOn: "2019-07-11T00:00:00",
                        EndOn: "2019-08-17T00:00:00"
                    },
                    {
                        Id: "test0101",
                        Title: "艾利根論文獎甄選活動!!",
                        Image: require("@/assets/dev/img3.png"),
                        StartOn: "2019-07-11T00:00:00",
                        EndOn: "2019-08-17T00:00:00"
                    },
                    {
                        Id: "test0101",
                        Title: "艾利根論文獎甄選活動!!",
                        Image: require("@/assets/dev/img4.png"),
                        StartOn: "2019-07-11T00:00:00",
                        EndOn: "2019-08-17T00:00:00"
                    },
                    {
                        Id: "test0101",
                        Title: "艾利根論文獎甄選活動!!",
                        Image: require("@/assets/dev/img2.png"),
                        StartOn: "2019-07-11T00:00:00",
                        EndOn: "2019-08-17T00:00:00"
                    }
                ];
            }
        }
    },
    mounted() {
        const windowSize = window.innerWidth;
        if(windowSize <= 420) {
            $('p').css('text-indent','0')
        }
    },
    watch: {}
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
#submission .list_box {
    margin-bottom: 60px;
}
#submission .list {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    align-items: stretch;
    margin-bottom: 60px;
}
#submission .list:after {
    content: "";
    flex: 0 0 30%;
    width: 30%;
    max-width: 350px;
}
#submission .list .item {
    width: 30%;
    max-width: 350px;
    margin-bottom: 30px;
    transition: 0.5s;
}
#submission .list .item:hover {
    transform: translateY(-2px);
}
#submission .box {
    border: 8px solid #eee;
    padding: 20px 30px;
    display: flex;
    flex-direction: column;
}
#submission .box .title {
    letter-spacing: 2px;
    line-height: 1.5;
    text-align: center;
    margin-bottom: 30px;
}
#submission .box .img {
    font-size: 0;
    width: 300px;
    margin: auto;
}
#submission .box .img img {
    width: 100%;
}
#submission .box .border {
    width: 100%;
    background-color: #ddd;
    height: 1px;
    margin: 30px auto;
}
#submission .box .tr {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    margin-bottom: 10px;
    color: #666;
    /* justify-content: space-between; */
}
#submission .box .tr > div:nth-child(1) {
    background: #eee;
    padding: 16px 12px;
    margin-right: 15px;
}
#submission .box .tr > div:nth-child(2),
#submission .box .tr > a {
    border-bottom: 1px solid #eee;
    text-decoration: none;
    padding: 16px 12px;
    color: #666;
    display: flex;
    align-items: center;
    flex: 1;
}
#submission .box .content {
    color: #666;
    padding: 60px 0;
    line-height: 1.5;
    letter-spacing: 3px;
}
#submission .box .content >>> p,
#submission .box .content >>> ul {
    padding: 20px 0;
    line-height: 1.5;
    letter-spacing: 3px;
}
#submission .box .content >>> ul li {
    padding: 8px 0;
}
#submission .box .content >>> strong {
    font-weight: 600;
    color: #000;
}
#submission .box .btn_box {
    width: 165px;
    margin: 15px auto;
}
#submission .box .submission_box {
    height: 0;
    overflow: hidden;
    transition: 1s;
}
#submission .box .submission_box.active {
    padding: 15px 0;
    height: 567px;
}
#submission .box .submission_box .subtitle {
    color: #ee8b59;
    font-size: 1.5rem;
    border-bottom: 1px solid #eee;
    padding: 8px 20px 16px;
    margin-bottom: 15px;
}
#submission .box .submission_box .input_span label {
    display: block;
    padding: 5px 24px;
    background-color: #a59b92;
    color: #fff;
    border-radius: 5px;
    cursor: pointer;
}
#submission .box .submission_box .input_span .note {
    letter-spacing: 2px;
    padding: 5.5px 0;
}
#submission .box .submission_box .input_span input[type="file"] {
    display: none;
}
#submission .box .submission_box .btn_box {
    /* margin: auto; */
    width: 50%;
    display: flex;
    align-items: center;
    justify-content: space-around;
    padding: 30px 0px;
}
#submission .box .submission_box .btn_box .item {
    width: 48%;
}
.file_name {
    display: flex;
    align-items: center;
    flex: 1;
}
.file_name input {
    flex: 1;
    /* margin-right: 10px; */
}
.file_name .delete {
    cursor: pointer;
    display: flex;
    align-items: center;
}
.file_name .delete span:nth-child(1) {
    color: #f00;
    font-weight: 600;
    padding: 0 10px;
    font-size: 1.5rem;
}
.file_name .delete span:nth-child(2) {
    font-weight: 600;
    display: flex;
    align-items: center;
    cursor: pointer;
}
@media screen and (max-width: 992px) {
    #submission .list .item {
        width: 48%;
        max-width: none;
    }
}
@media screen and (max-width: 767px) {
    #submission .box {
        padding: 20px 10px;
    }
    #submission .box .tr > div:nth-child(1) {
        background: #eee;
        padding: 16px 12px;
        margin-right: 0;
        width: 100%;
    }
    #submission .box .tr > div:nth-child(2),
    #submission .box .tr > a {
        border-bottom: 1px solid #eee;
        text-decoration: none;
        padding: 16px 12px;
        color: #666;
        flex: 1;
        line-height: 1.2;
    }
    #submission .list .item {
        width: 100%;
        max-width: none;
    }
    #submission .box .btn_box {
        width: 100%;
    }
    #submission .box .submission_box.active {
        height: 700px;
    }
    #submission .box .submission_box .btn_box {
        width: 100%;
    }
    #submission .box .content {
        padding: 20px 0;
    }
}
</style>



// WEBPACK FOOTER //
// src/pages/submission.vue